
const API_DATASHEET_PREFIX = 'api/datasheet';

/**
 * Rename format endpoints
 */
export const RENAME_FORMAT_ENDPOINTS = {
  /** Rename a regular datasheet format */
  DS: `${API_DATASHEET_PREFIX}/renameDSFormat`,
  /** Rename a table datasheet (TDS) format */
  TDS: `${API_DATASHEET_PREFIX}/renameDSFormat?type=8`,
} as const;
